<template>
  <div class="container" v-wechat-title="$route.meta.title">
    
    <!-- 营业报表 -->
    <div class="onePart">
      <div v-if="changeIndex == 0" v-bind:class="{ day:changeIndex== 0,'date-bar':1}">{{showDate(beginDay)}}</div>
      <div v-if="changeIndex == 2" class="date-bar">{{showDate(beginDay,'y')}} <span @click="selectDate('sub')">&lt;&lt;</span> {{showDate(beginDay,'m')}} <span @click="selectDate('add')">&gt;&gt;</span></div>
      <div v-if="changeIndex == 1" class="date-bar">{{showDate(beginDay,'y')}} <span @click="selectDate('sub')">&lt;&lt;</span> {{showDate(beginDay,'d')}} - {{showDate(endDay,'d')}} <span @click="selectDate('add')">&gt;&gt;</span></div>
      <div class="topChange disp-just-aro-ali-cen">
        <div @click="changeType" :index="0" :class="[changeIndex==0?'div1':'div2']">今日</div>
        <div @click="changeType" :index="1" :class="[changeIndex==1?'div1':'div2']">周报</div>
        <div @click="changeType" :index="2" :class="[changeIndex==2?'div1':'div2']">月报</div>
      </div>
      <div class="wrap disp-ali-cen">
        <div v-if="changeIndex == 0" class="info info3 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日采购货值（元）<p @click="checkQues('今日采购货值_'+(changeIndex+1))" class="ques"></p></div>
          <div><span style="font-size: 0.34rem;">￥</span>{{getOneDimension("采购总货值",0)}}</div>
          <div>昨日采购货值：￥{{getOneDimension("昨日采购总货值",0)}}</div>
        </div>
        <div v-if="changeIndex == 0" class="info info3 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">今日采购数量（件）<p @click="checkQues('今日采购数量_'+(changeIndex+1))" class="ques"></p></div>
          <div>{{getOneDimension("采购件数",0)}}</div>
          <div>昨日采购数量：{{getOneDimension("昨日采购件数",0)}}</div>
        </div>
      </div>
    </div>
    <!-- 采购商品分布 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        采购商品分布（元）<p @click="checkQues('采购商品分布_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="pieOne" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
    <!-- 供应商占比 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        供应商占比（元）<p @click="checkQues('供应商占比_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="pieTwo" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
    <!-- 表格 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        供应商供货分布（元）<p @click="checkQues('供应商供货分布_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div class="table-box">
        <div class="table-div table-div2">
          <table class="data-table data-table2">
            <tr v-for="(item,i) in getProdNumByDay">
              <th v-if="i==0 && j==0" v-for="(sub,j) in item">{{sub}}</th>
              <td v-if="i!=0 && j==0" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>

        <div class="table-div">
          <table class="data-table data-table-gys">
            <tr v-for="(item,i) in getProdNumByDay">
              <th v-if="i==0" v-for="(sub,j) in item">{{sub}}</th>
              <td v-if="i!=0" v-for="(sub,j) in item">{{sub}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
     <div class="divPlaceholder">&nbsp;</div>
    <!-- loading的显示隐藏 -->
    <!-- <van-popup :close-on-click-overlay="false" v-model="loadShow">
      <van-loading size="24px" vertical>加载中...</van-loading>
    </van-popup> -->
    <Loading v-show="loadShow"></Loading>
    <popupWin v-if="popupIsShow" :popupShow="isPopupShow" :keyWords="keyWord" @childRe="childReturn"></popupWin>
  </div> 
</template>
<script>
  import Vue from 'vue'
  import util from '../../static/js/util'
  import {
    Toast
  } from 'vant';
  Vue.use(Toast);
  import baseUrl from '../../static/js/basedata.js'
  import {
    Loading
  } from 'vant';
  Vue.use(Loading);

  export default {
    name: 'InfoPage',
    data() {
      return {
        changeIndex: 0,
        beginDay: new Date(),
        endDay: new Date(),
        RptData: {},
        loadShow: false,
        show: false,
        minDate: new Date(),
        maxDate: new Date(2999, 1, 1),
        isPopupShow: false,
        keyWord:'',//带入组件关键字
        popupIsShow:false,
        popupShow:false,//底部弹框是否显示
        keyWords:'',
        popupTitle:'弹框标题',//弹框标题
        popupContent:'弹框内容',//弹框标题
      }
    },
    computed: {
      getDate: function () {
        if (this.changeIndex == 0) {
          return this.formatDate(new Date(this.beginDay));
        } else {
          return `${this.formatDate(new Date(this.beginDay))} - ${this.formatDate(new Date(this.endDay))}`
        }
      },
      getProdNumByDay: function () {
          
        var para = { X: "供应商", Y: "商品大类", Z: 0 };
        var rst = this.$util.getThreeDimensionTable(this.RptData.Items, "采购供应商品类贡献分析", para);
        return rst;
      },
    },
    methods: {
      checkQues(_key){
        console.log(_key)
        this.isPopupShow = true;
        this.keyWord = _key;
        this.popupIsShow = true;
      },
      childReturn(data){
        console.log('data-----',data)
        this.isPopupShow = data;
        this.popupIsShow = data;
      },
      formatDate(date) {
        // 今日选择
        if (this.changeIndex == 0) {
          return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
        } else if (this.changeIndex == 1) {
          // 周选择
          return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
        } else if (this.changeIndex == 2) {
          // 月选择
          return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
        }
      },
      showDate(date, mode) {
        // 今日选择
        mode = mode || 'a';
        date = new Date(date);
        if (this.changeIndex == 0) {
          return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
        } else if (this.changeIndex == 1) {
          if (mode === 'y') {
            return `${date.getFullYear()}年`;
          }
          if (mode === 'd')
            return `${date.getMonth() + 1}月${date.getDate()}日`;
        } else if (this.changeIndex == 2) {
          // 月选择
          if (mode === 'y') {
            return `${date.getFullYear()}年`;
          }
          if (mode === 'm')
            return `${date.getMonth() + 1}月`;
        }
      },
      selectDate(mode) {
        if (this.changeIndex == 2) {
          if (mode === 'add') {
            var date = new Date(this.beginDay);
            date.setDate(1);
            date.setMonth(date.getMonth() + 1);
            this.beginDay = date.format("yyyy-MM-dd");
            var date = new Date(this.beginDay);
            date.setMonth(date.getMonth() + 1);
            date.setDate(0);
            this.endDay = date.format("yyyy-MM-dd");
          } else if (mode === 'sub') {
            var date = new Date(this.beginDay);
            date.setDate(1);
            date.setMonth(date.getMonth() - 1);
            this.beginDay = date.format("yyyy-MM-dd");
            var date = new Date(this.beginDay);
            date.setMonth(date.getMonth() + 1);
            date.setDate(0);
            this.endDay = date.format("yyyy-MM-dd");
          }
          this.loadData();
        }
        if (this.changeIndex == 1) {
          if (mode === 'add') {
            var date = new Date(this.beginDay);
            date.setDate(date.getDate() + 7);
            this.beginDay = date.format("yyyy-MM-dd");
            var date = new Date(this.beginDay);
            date.setDate(date.getDate() + 6);
            this.endDay = date.format("yyyy-MM-dd");
          } else if (mode === 'sub') {
            var date = new Date(this.beginDay);
            date.setDate(date.getDate() - 7);
            this.beginDay = date.format("yyyy-MM-dd");
            var date = new Date(this.beginDay);
            date.setDate(date.getDate() + 6);
            this.endDay = date.format("yyyy-MM-dd");
          }
          this.loadData();
        }
      },
      onConfirm(date) {
        if (this.changeIndex == 0) {
          this.beginDay = date.format("yyyy-MM-dd");
          this.endDay = date.format("yyyy-MM-dd");
        } else {
          const [start, end] = date;
          this.beginDay = start.format("yyyy-MM-dd");
          this.endDay = end.format("yyyy-MM-dd");
        }
        this.loadData();
      },

      changeType(e) {
        var index = e.target.getAttribute('index');
        this.changeIndex = Number(index);
        var date = this.$dateUtil.today();
        switch (this.changeIndex) {
          case 0:
            date = this.$dateUtil.today();
            break;
          case 1:
            date = this.$dateUtil.thisWeek();
            break;
          case 2:
            date = this.$dateUtil.thisMonth();
            break;
        }
        this.beginDay = date.Begin;
        this.endDay = date.End;
        this.loadData();
      },
      loadData() {
        var that = this;
        that.loadShow = true;
        this.show = false;
        var query = {
          ReportType: this.$util.AppReportType.采购报表,
          Begin: this.beginDay,
          End: this.endDay
        };
        this.$api.get("/AppReport", query, function (res) {

          that.RptData = res;
          that.drawPie();
          that.loadShow = false;
        }, function (err) { that.loadShow = false; });
      },

      backLast() {
        this.$router.go(-1); //返回上一层
      },
      getOneDimension(subTypeName, def) {
        return this.$util.getOneDimension(this.RptData.Items, subTypeName, def)
      },
      getTwoDimension(subTypeName, defX, defY) {
        return this.$util.getTwoDimension(this.RptData.Items, subTypeName, defX, defY)
      },
      drawPie() {
      
        var pieOneData = this.getTwoDimension("采购商品额分布", "", "0");
        this.$echarts.init(document.getElementById('pieOne')).setOption(this.$util.PieOption(pieOneData,"元"));

        var pieTwoData = this.getTwoDimension("采购供应商占比", "", "0");
        this.$echarts.init(document.getElementById('pieTwo')).setOption(this.$util.PieOption(pieTwoData,"元"));
 
    


      }
    },
    mounted() {
     
      var date = this.$dateUtil.today();
      this.beginDay = date.Begin;
      this.endDay = date.End;
      this.loadData();
       phoneDevice.setTitle(this.$route.meta.title || "");
    }
  }
</script>

<style>
  @import url("../../static/css/common.css");
  
  .topChange {
    width: 100%;
    margin-bottom: 0.53rem;
  }

  .topChange .div1 {
    width: auto;
    font-size: 0.34rem;
    color: #1C1C1C;
    border-bottom: 0.05rem solid #1699E5;
  }

  .topChange .div2 {
    width: auto;
    font-size: 0.34rem;
    color: #999999;
    border-bottom: 0.05rem solid transparent;
  }

  .container {
    width: 10rem;
    min-height: 100vh;
    background: #f2f2f2;
    /* background: pink; */
    padding: 0 0.34rem 0.4rem;
    box-sizing: border-box;
    border-top: 0.01rem solid transparent;
  }

  .table-div2{
    width: 3.35rem;
  }
  .data-table tr th,.data-table tr td{
    width: 3.3rem;
    height: 1.07rem;
    overflow: hidden;
    /* white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden; */
  }
  /* .data-table-gys tr th:first-of-type,.data-table-gys tr td:first-of-type{
    width: 2.2rem;
  } */
  .wrap .info1 {
    background-image: url(../assets/indexImage/img10.png);
  }

  .wrap .info2 {
    background-image: url(../assets/indexImage/img2.png);
  }

  .wrap .info3 {
    background-image: url(../assets/indexImage/img4.png);
  }

  .wrap .info4 {
    background-image: url(../assets/indexImage/img6.png);
  }

  .wrap .info5 {
    background-image: url(../assets/indexImage/img12.png);
  }

  .wrap .info6 {
    background-image: url(../assets/indexImage/img8.png);
  }

</style>



// WEBPACK FOOTER //
// src/components/caigoubaobiao.vue